/*******************************************************************************
 * @ngdoc object
 * @name  csm.payments.services.service:PaymentsData.pace.BillingInfo
 * @description
 * Web payment billing information for Pace. Includes data from PaymentFrame API.
 *******************************************************************************/
export function paceWebPaymentConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'PaymentsData.pace.BillingInfo',
    $type: 'csm.payments.pace.data.BillingInfo, PaymentsCS',
    prototype: {
      cardType: null // Card type from PaymentFrame API.
    }
  });
};

paceWebPaymentConfig.$inject = ['TypeFactoryProvider'];
